"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var create_report_html_1 = __importDefault(require("./create-report.html"));
var create_report_controller_1 = __importDefault(require("./create-report.controller"));
function getReportBuilderConfig(ReportBuilder) {
    return ReportBuilder.getReportBuilderConfig().then(function (response) {
        return response.data;
    });
}
getReportBuilderConfig.$inject = ["ReportBuilder"];
function config($stateProvider, $urlRouterProvider) {
    $stateProvider.state("drivecoach.admin.reportbuilder.createreport", {
        url: "/create-report",
        controller: "CreateReportController",
        controllerAs: "vm",
        template: create_report_html_1.default,
        resolve: {
            ReportBuilderConfig: getReportBuilderConfig,
        },
    });
}
config.$inject = ["$stateProvider", "$urlRouterProvider"];
exports.default = angular_1.default
    .module("drivecoach.admin.reportbuilder.createreport", [])
    .config(config)
    .controller("CreateReportController", create_report_controller_1.default);
